import React from 'react'
import Portal from '../../../../component/portal'
import { AppContext, getDefaultState } from '../../../../config/context'
import { safeParse, clearUserInfoLocally, getCurrentDomain, getLocalChannelId } from '../../../../common/util'
import { loginFor9891 } from './service'
import Login from '../../../../component/login'
import Cert from '../../../../component/cert'
import ee, { EVENT_USER_INVALID, EVENT_USER_LOGIN, EVENT_TIP, EVENT_USER_LOGOUT, EVENT_LANG_CHANGE, EVENT_USER_CERT } from '../../../../common/util/event'

const MESSAGE_USER_INFO = 'USER_INFO'
const MESSAGE_USER_CERT = 'USER_CERT'
const MESSAGE_USER_INVALID = 'USER_INVALID'
const MESSAGE_CLIENT_HEIGHT = 'CLIENT_HEIGHT'
const MESSAGE_CLIENT_DOMAIN = 'CLIENT_DOMAIN'
const MESSAGE_GOTO_ORDER = 'GOTO_ORDER'
const MESSAGE_GOTO_SUBMIT = 'GOTO_SUBMIT'
const MESSAGE_UPDATE_STEP = 'UPDATE_STEP'
const MESSAGE_USER_LANG = 'USER_LANG'

class Frame9891 extends React.Component {
    constructor() {
        super(...arguments)
        const { lang } = this.context.user
        const pid = getLocalChannelId()
        const frameSrc = window._inject_app_data_.frameSrc
        this.state = {
            frameSrc: `${frameSrc}${frameSrc.indexOf('?') > 0 ? '&' : '?'}lang=${lang}&pid=${pid}`,
            frameHeight: '607',
            showLoginModal: false,
            showCertModal: false
        }
    }

    componentDidMount() {
        window.addEventListener('message', this.messageHandler)
        ee.addListener(EVENT_USER_LOGIN, () => {
            this.postUserInfo()
        })
        ee.addListener(EVENT_USER_LOGOUT, () => {
            this.postUserInvalid()
        })
        ee.addListener(EVENT_USER_INVALID, () => {
            clearUserInfoLocally()
            this.context.updateUserInfo(getDefaultState())
            this.showLoginModal()
            this.postUserInvalid()
        })
        ee.addListener(EVENT_LANG_CHANGE, lang => {
            this.postUserLang(lang)
        })
        ee.addListener(EVENT_USER_CERT, this.postUserCert)
    }

    showLoginModal = () => {
        this.setState({
            showLoginModal: true
        })
    }

    showCertModal = () => {
        this.setState({
            showCertModal: true
        })
    }

    messageHandler = message => {
        const messageData = safeParse(message.data)
        if (!messageData) {
            return
        }
        const { type } = messageData
        if (type === MESSAGE_USER_INFO) {
            const { isLogin, phone } = this.context.user
            if (isLogin !== 1 || !phone) {
                window._imp = true
                window._impc = true
                return this.showLoginModal()
            }
            this.postUserInfo()
        } else if (type === MESSAGE_USER_CERT) {
            const { isLogin, phone, age, isAuth } = this.context.user
            if (isLogin !== 1 || !phone) {
                window._imp = true
                window._impc = true
                return this.showLoginModal()
            }
            if (isAuth === 1 && age >= 18) {
                return this.postUserCert()
            }
            this.showCertModal()
        } else if (type === MESSAGE_CLIENT_HEIGHT) {
            this.setState({
                frameHeight: messageData.data.height + ''
            })
        } else if (type === MESSAGE_CLIENT_DOMAIN) {
            this.postClientDomain()
        } else if (type === MESSAGE_GOTO_ORDER) {
            location.href = '/order/dc/list.html'
        } else if (type === MESSAGE_GOTO_SUBMIT) {
            location.href = '/dc/submit?step=1'
        } else if (type === MESSAGE_UPDATE_STEP) {
            try {
                history.replaceState(null, '', `/dc/submit?step=${messageData.data.step}`)
            } catch (e) { }
        }
    }

    postUserInfo = () => {
        loginFor9891().then(data => {
            this.frameTarget.contentWindow.postMessage(JSON.stringify({ type: MESSAGE_USER_INFO, data }), '*')
        }).catch(e => {
            e.code !== 401 && ee.emit(EVENT_TIP, e.message)
        })
    }

    postUserCert = () => {
        this.frameTarget.contentWindow.postMessage(JSON.stringify({ type: MESSAGE_USER_CERT, data: true }), '*')
    }

    postUserLang = lang => {
        this.frameTarget.contentWindow.postMessage(JSON.stringify({ type: MESSAGE_USER_LANG, data: lang }), '*')
    }

    postUserInvalid = () => {
        this.frameTarget.contentWindow.postMessage(JSON.stringify({ type: MESSAGE_USER_INVALID }), '*')
    }

    postClientDomain = () => {
        this.frameTarget.contentWindow.postMessage(JSON.stringify({ type: MESSAGE_CLIENT_DOMAIN, data: getCurrentDomain() }), '*')
    }

    closeLoginModal = () => {
        this.setState({
            showLoginModal: false
        })
    }

    closeCertModal = () => {
        this.setState({
            showCertModal: false
        })
    }

    render() {
        const { frameSrc, frameHeight, showLoginModal, showCertModal } = this.state
        return <div>
            <iframe src={frameSrc} width="100%" height={frameHeight} frameborder="0" scrolling="no" style={{ display: 'block' }} ref={dom => this.frameTarget = dom}></iframe>
            {
                showLoginModal && <Login close={this.closeLoginModal}></Login>
            }
            {
                showCertModal && <Cert close={this.closeCertModal}></Cert>
            }
        </div>
    }
}

Frame9891.contextType = AppContext
export default Portal(Frame9891, 'frame-page-container')